<template>
  <p :class="$style.text"><slot /></p>
</template>

<style lang="scss" module>
.text {
  font-size: 12px;
  font-weight: bold;
  line-height: 20px;

  &::before {
    display: inline-block;
    width: 8px;
    height: 8px;
    margin-right: 4px;
    color: inherit;
    background-color: currentcolor;
    border-radius: 100vmax;
    content: '';

    // 0.5px分だけ●の位置を調整する
    transform: translateY(-0.5px);
  }
}
</style>
